import React, { useEffect, useCallback, useMemo } from "react";
import { connect } from "react-redux";
import { css } from "emotion";

import { loadingStyle } from "./style";
import Loading from "../../../../../../shared/Loading/Loading";

import { useNewOffer } from "../../../../../../js/context/new-offer";
import { refreshOffers, isNewUser } from "../../../../../actions";
import {
	ROUTE_PREFIX_EDIT_OFFER_MOBILE,
	prefixFinished,
	prefixFinishedError
} from "../../../../../shared/constants";
import { handleFidelityNameToPath } from "../../../../../shared/utils";

import { publish } from "pubsub-js";
import eventType from "../../../../../events/eventType";

const StepEditFinished = ({ refreshOffers, isNewUser, history }) => {
	const {
		currentProgram,
		offerSentStatus,
		fetchOffersData,
		offerData,
		isEditOffer,
		editOffer,
		loyaltyData
	} = useNewOffer();

	const registerEvent = useCallback(() => {
		const { fidelityName, international } = currentProgram;
		const { quant: quantityMiles, price: priceMiles, averageMiles } = offerData?.data;
		const { paymentDeadline } = editOffer;
		const step = isEditOffer ? "edicao-conclusao-oferta" : "conclusao-oferta";
		const { twoFactorAuthenticationStrategy } = loyaltyData.data;

		publish(eventType.OFFER_CONTENT, {
			fidelityName,
			international,
			quantityMiles,
			priceMiles,
			step,
			averageMiles,
			paymentDeadline,
			twoFactorAuthenticationStrategy
		});
	}, [currentProgram, offerData, isEditOffer, editOffer, loyaltyData]);

	useEffect(() => {
		if (offerSentStatus.isDone) {
			fetchOffersData(); // atualiza offers do context
			refreshOffers(); // atualiza offers do redux
			isNewUser(false); // atualiza caso for novo usuario trocar a tela inicial
			if (offerSentStatus.success) {
				if(isEditOffer) registerEvent();
				history.push(
					`${ROUTE_PREFIX_EDIT_OFFER_MOBILE}/${prefixFinished}/${handleFidelityNameToPath(
						currentProgram
					)}`
				);
			} else {
				history.push(
					`${ROUTE_PREFIX_EDIT_OFFER_MOBILE}/${prefixFinishedError}/${handleFidelityNameToPath(
						currentProgram
					)}`
				);
			}
		}
	}, [offerSentStatus, registerEvent, isEditOffer]);

	return (
		<div
			className={css`
				${loadingStyle};
			`}
		>
			<strong>Quase lá!</strong>
			<span>Estamos finalizando seu cadastro.</span>
			<Loading width={120} height={120} />
		</div>
	);
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => {
	return {
		refreshOffers: () => dispatch(refreshOffers()),
		isNewUser: newUser => dispatch(isNewUser(newUser))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(StepEditFinished);
